module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABJAQMAAADG0N7LAAAAA1BMVEXS0tLypMjhAAAAC0lEQVQI12MYdAAAAJIAATAgdPgAAAAASUVORK5CYII="